export const idlyData= [{
    "id":"1",
    "name":"Plain Idli",
    "price":"Price :₹35",
    "image": process.env.PUBLIC_URL + "/assests/idli/2.jpg",
    "description": "A classic breakfast favorite—steamed, fluffy, and incredibly soft rice cakes served with traditional peanut chutney and sambar."
},
{
    "id":"2",
    "name":"Sambar Idli",
    "price":"Price :₹50",
    "image": process.env.PUBLIC_URL + "/assests/idli/3.webp",
    "description": "Two soft, pillowy idlis completely submerged in a bowl of piping hot, aromatic sambar made with mixed vegetables and traditional spices."
},
{
    "id":"3",
    "name":"Ghee Idli",
    "price":"Price :₹65",
    "image": process.env.PUBLIC_URL + "/assests/idli/1.jpg",
    "description":"Soft, fluffy idlis mini-dipped or smeared with pure ghee and podi masala."
}]